<template>
    <div>
      <v-card class="overflow-hidden v-card v-sheet theme--light">
        <!-- Alert Messages -->
        <div>
          <v-alert :type="alert_type" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
        </div>
        <!-- ######## Main page ######## -->
        <HeaderComponent :headerTitle="headerText" :router-link="{ name: 'ReturnCreationRia' }"
          :router-link-text="action_title" :return-condition="true" :component-name="return_sub_request_id">
        </HeaderComponent>
        <!-- <HeaderComponent :headerTitle="headerText" :IrrdDetails="IrrdDetails" :tagNumber="tagNumber"/> -->
        <!-- Add Tag Ids Popup -->
        <v-row justify="center">
          <v-dialog v-model="tagIdsPopup" persistent max-width="600px">
            <v-card class="v-card-100">
              <v-card class="v-card-100">
                <v-card-title class="d-flex">
                  <span>Add Tag Ids</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeTagIdsPopup">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6" style="height: 96px;">
                        <v-text-field label="Enter Article ID" prepend-inner-icon="mdi-magnify" outlined v-model="articleId" style="margin-bottom: -30px;" required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" style="height: 96px;">
                        <v-text-field label="Enter Tag ID" prepend-inner-icon="mdi-magnify" outlined v-model="tagId" style="margin-bottom: -30px;" required></v-text-field>
                      </v-col>
                    </v-row>       
                  </v-container>
                </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined class="mb-3 disabled-color-outlined" @click="saveTagDataPopup" :disabled="!articleId && !tagId">SAVE & CLOSE</v-btn>
                <v-btn color="primary" class="mb-3 disabled-color" @click="TagIdDataPopup" :disabled="!articleId && !tagId">CONTINUE</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Added Tag Ids Popup -->
        <v-row justify="center">
          <v-dialog v-model="addedTagIdsPopup" persistent max-width="366px">
            <v-card class="v-card-100">
              <v-card class="v-card-100">
                <v-card-title class="d-flex">
                  <span>Add Tag Ids</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeAddedTagIdsPopup">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
                <v-card-text>
                  <v-container>
                      <v-col cols="6" sm="12" md="12" style="height: 96px;">
                        <v-text-field label="Add Tag" prepend-inner-icon="mdi-magnify" outlined v-model="addTag" style="margin-bottom: -30px;" required></v-text-field>
                      </v-col>
                  </v-container>
                </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-3 disabled-color" @click="saveAddedTagIds" :disabled="!addTag">SAVE & CLOSE</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Confirm Dispatch Date Popup -->
        <v-row justify="center">
          <v-dialog v-model="dispatchDatePopup" persistent max-width="366px">
            <v-card class="v-card-100">
              <v-card class="v-card-100">
                <v-card-title class="d-flex">
                  <span>Add Tag Ids</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeDispatchDatePopup">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
                <v-card-text>
                  <v-container>
                      <v-col cols="6" sm="12" md="12" style="height: 96px;">
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="dispatchDate" transition="scale-transition" offset-y min-width="290px" class="ma-2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field outlined hide-details v-model="dispatchDate" label="DD/MM/YYYY" prepend-inner-icon="event" readonly v-bind="attrs" v-on="on" class="ma-2" ></v-text-field>
                          </template>
                          <v-date-picker :max="new Date().toISOString().substr(0, 10)" v-model="dispatchDate" no-title scrollable class="ma-2">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.menu1.save(dispatchDate)">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                  </v-container>
                </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-3 disabled-color" @click="submitDispatchDate" :disabled="!dispatchDate">Submit</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Actions & Search -->
        <v-card-title>
          <!-- search -->
          <v-row>
            <v-col cols="8" sm="8">
              <v-text-field prepend-inner-icon="mdi-magnify" v-model="return_search" label="Search" style="max-width: 300px;" outlined @keyup.enter="searchData"></v-text-field>
            </v-col>
          </v-row>
  
          <!-- Action btns -->
          <v-actions style="display: flex;margin-bottom: 28px;">
            <v-btn class="ma-2" color="primary"  @click="openTagIdPopup">ADD TAGS</v-btn>  
            <v-btn class="ma-2" color="primary" @click="openDispatchDatePopup">CONFIRM DATE</v-btn>
            <v-btn class="ma-2" color="primary" :disabled="isSubmitDisabled">Submit</v-btn>
          </v-actions>
          
        </v-card-title>
        <v-card-text class="border-top">
          <v-row class="returnmb">
            <v-col cols="12" sm="3" v-model="approvalId" md="3" style="text-align: center;">Invite Pull Back : {{ return_sub_request_id }}</v-col>
            <v-col cols="12" sm="3" v-model="invitePullback" md="3" style="text-align: center;">Invite Pull Back : {{ return_sub_request_id }}</v-col>
            <v-col cols="12" sm="3" v-model="returnWindow" md="3" style="text-align: center;">Return Window : 01/01/2024 To 31/01/2024</v-col>
            <v-col cols="12" sm="3" v-model="validPeriod" md="3" style="text-align: center;">Valid Period: 01/01/2024 To 31/01/2024</v-col>
            <v-col cols="12" sm="3" v-model="approvalValue" md="3" style="text-align: center;">Approval Value: 13,00,000</v-col>
            <v-col cols="12" sm="3" v-model="confirmValue" md="3" style="text-align: center;">Confirm Value: 13,00,000</v-col>
            <v-col cols="12" sm="3" v-model="actualValue" md="3" style="text-align: center;">Actual Value: 0</v-col>
          </v-row>
        </v-card-text>
        <v-layout column>
          <v-flex md6 style="overflow: auto">
            <v-data-table 
              :dense="true"  
              v-model="selected" 
              show-select
              disable-pagination 
              :hide-default-footer="true"
              :headers="headers" 
              :items="table_data" 
              :loading="loading" 
              loading-text="Loading Data... Please wait"
              class="elevation-1">
              <template #[`item.article_id`]="{ item }" >
                <a style="color: #1976d2;">
                  <u> {{ item.article_id }}</u>
                </a>
              </template>
              <template #[`item.tag_ids`]="{ item }" >
                <a style="color: #1976d2;" @click="openAddedTagIdPopup">
                  <u> {{ item.tag_ids }}</u>
                </a>
              </template>
              <template #[`item.actual_quantity`]="{ item }">
                <div class="quantity-div">
                  <button class="minus" @click="decreaseQuantity">-</button>
                    <span type="number" class="quantity" min="0">{{ item.actual_quantity }}</span>
                  <button class="plus" @click="increaseQuantity">+</button>
                </div>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
  
        <div class="float-right">
          <v-row class="ml-2">
            <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per page"
              @update:modelValue="handlePageSizeChange"></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                prev-icon="mdi-menu-left" @update:modelValue="handlePageChange"></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
  </template>
  <script>
    import $ from 'jquery';
  import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
    export default {
      components: {
        HeaderComponent,
      },
      data() {
        return {
          headerText: "Return Creation",
          ReturnCreationRia: true,
          isSubmitDisabled: true,
          actualQuantity: '',
          search_tag: '',
          menu1: '',
          returnWindow: '',
          approvalId: '',
          confirmValue: '',
          addedTagIdsPopup: false,
          dispatchDatePopup: false,
          tagIdsPopup: false,
          dispatchDate: '',
          invitePullback: '',
          articleId: '',
          tagId: '',
          validPeriod: '',
          approvalValue: '',
          actualValue: '',
          updatepopinitem: false,
          loading: false,
          datadetailpopuptestresults: false,
          alert: false,
          return_search: '',
          selected: [],
          alert_type: "success",
          alert_message: "success",
          headers: [],
          table_data: [],
          page: 1,
          pageSize: 25,
          pageSizes: [25, 50, 75, 100],
          totalPages: 1,
          action_title: '',
          return_sub_request_id: '',
        }
      },
      async created() {
        this.action = this.$store.state.action;
        const item_detail = JSON.parse(this.$store.state.items);
        this.return_sub_request_id = item_detail.return_sub_request_id;
        this.action_title = 'Invite Pullback Return'
        this.loadData();
      },
      methods: {
        searchData(){
  
        },
        loadData(){
          this.loading = true;
          this.selected = []
          this.table_data = [
            {article_id: '1234', article_description: 'test1', price: '250.00', eligible_quantity: '5', tag_ids: '5', actual_quantity: '2', received_quantity: "5"},
            {article_id: '1235', article_description: 'test2', price: '251.00', eligible_quantity: '6', tag_ids: '6', actual_quantity: '3', received_quantity: "6"},
            {article_id: '1236', article_description: 'test3', price: '252.00', eligible_quantity: '7', tag_ids: '7', actual_quantity: '4', received_quantity: "7"},
            {article_id: '1237', article_description: 'test4', price: '253.00', eligible_quantity: '8', tag_ids: '8',actual_quantity: '5', received_quantity: "8"},
          ]
          this.page = 1
          this.totalPages = 1
          this.pageSize = 100
          this.headers = [
              { title: "Article ID", key: "article_id"},
              { title: "Article Description", key: "article_description", sortable: false },
              { title: "Price", key: "price" },
              { title: "Eligible Quantity", key: "eligible_quantity"},
              { title: "Tag IDs", key: "tag_ids"},
              { title: "Actual Quantity", key: "actual_quantity" },
              { title: "Received Quantity", key: "received_quantity" },
            ];
            this.maindata();
            this.getrequestTypes();
        },
        maindata() {
          this.return_search = ''
          const params = this.getRequestParams(this.page, this.pageSize);
        },
        getrequestTypes(){
  
        },
        filterListOfButtons(){
  
        },
        openTagIdPopup() {
          this.tagIdsPopup = true;
        },
        openAddedTagIdPopup(){
          this.addedTagIdsPopup = true;
        },
        closeAddedTagIdsPopup() {
          this.addedTagIdsPopup = false;
        },
        saveAddedTagIds() {
          this.addedTagIdsPopup = false;
        },
        closeTagIdsPopup(){
          this.tagIdsPopup = false;
        },
        saveTagDataPopup() {
          this.tagIdsPopup = false;
        },
        TagIdDataPopup() {
  
        },
        openDispatchDatePopup() {
          this.dispatchDatePopup = true;
        },
        closeDispatchDatePopup() {
          this.dispatchDatePopup = false;
        },
        submitDispatchDate(){
          this.dispatchDatePopup = false;
          this.$router.push('/api/v1/return-creation');
        },
        increaseQuantity() {
          this.actualQuantity++;
        },
        decreaseQuantity() {
          if (this.actualQuantity > 0) {
            this.actualQuantity--;
          }
        },
        handlePageChange(value) {
          this.page = value;
          this.maindata();
        },
        handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
        this.maindata();
        },
        getRequestParams(page, pageSize) {
          let params = {};
  
          if (page) {
            params["page"] = page;
          }
          if (pageSize) {
            params["size"] = pageSize;
          }
          return params;
        },
        showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.alertTimeOut();
        },
        alertTimeOut() {
          setTimeout(() => {
            this.alert = false;
          }, 3000);
        },
      }
    }
  </script>
  <style scoped>
    /* .returnmb { */
      /* margin-bottom: -40px; */
    /* } */
    .returnmb>v-col{
      text-align: center;
      font-size: small;
  
    }
    .border-top{
      border-top: 18px solid #e5e5e5 !important;
    }
    .quantity-div {
      border: 1px solid #000;
      border-radius: 5px;
      width: 100px;
      padding: 2px;
    }
    .quantity {
      margin: 0px 8px;
    }
    .minus, .plus {
      width: 30px;
      border: 1px solid lightblue;
      border-radius: 5px;
    }
    .theme--light.v-btn.disabled-color-outlined.v-btn--disabled {
      opacity: 0.6 !important;
      color: #2B81D6 !important;
      border: 1px solid #2B81D6 !important;
    }
    .theme--light.v-btn.disabled-color.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
      opacity: 0.6 !important;
      color: #fff !important;
      background: #2B81D6 !important;
      border: 1px solid #2B81D6 !important;
    }
  </style>